import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { PackingStatus, ProductCategoryEnum, ShiftsDropDown, ShiftsEnum, StockStatus, StockTypesEnum, TransactionType } from "@gtpl/shared-models/common-models";
import { FgStockStatus } from "./dto/fg-stock-status.enum";
import { FgStockStates } from "./dto/fg-stock-states.enum";
import { Shifts } from "./dto/shifts.enum";
@Entity('stock')
export class Stock {

  @PrimaryGeneratedColumn("increment",{name:'stock_id'})
  stockId:number;

  @Column("varchar",{
    nullable:true,
    name:"lot_no"
    })
    lotNo:string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "soaking_time"
      })
      soakingTime: string;
    
    
      @Column("varchar", {
        nullable: true,
        length: 20,
        name: "soaking_style"
      })
      soakingStyle: string;
      @Column("int", {
        nullable: true,
        name: "pallet_code"
      })
      palletCode: number;
      @Column("int", {
        nullable: true,
        default: 0,
        name: "rack_type"
      })
      rackType: number;
      @Column({
        type: 'enum',
        enum: Shifts,
        nullable: false,
        name: 'shift'
    })
    shift: string;
      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "wh_incharge"
      })
    warehouseIncharge: string;
  @Column("int",{
      nullable:false,
      name:"sale_order_id"
      })
  saleOrderId:number;
  @Column("varchar",{
    nullable:true,
    name:"rack_position_code"
    })
    rackPositionCode:string;
    @Column("varchar",{
        nullable:true,
        name:"zone_code"
    })
    zoneCode:string;
    @Column("varchar",{
        nullable:true,
        name:"brand"
    })
    brand:string;
    @Column("varchar",{
        nullable:true,
        name:"product"
    })
    product:string;
    @Column("varchar",{
        nullable:true,
        name:"po_number"
    })
    poNumber:string;
    @Column("varchar",{
        nullable:true,
        name:"uom_code"
    })
    uomCode:string;
    @Column("varchar",{
        nullable:true,
        name:"category"
    })
    category:string;
    @Column("varchar",{
        nullable:true,
        name:"variant_code"
    })
    variantCode:string;
    @Column("varchar",{
        nullable:true,
        name:"unit_code"
    })
    unitCode:string;
    @Column("int",{
    nullable:true,
    name:"allocated_sale_order_id"
    })
    allocatedSaleOrderId:number;
    @Column("int",{
        nullable:true,
        name:"allocated_sale_orderitem__id"
        })
        allocatedSaleOrderItemId:number;
  @Column("int",{
      nullable:false,
      name:"sale_order_item_id"
      })
  saleOrderItemId:number;
  @Column("int",{
      nullable:false,
      name:"total_cartons"
      })
      totalCartons:number;
      @Column("int",{
        nullable:true,
        // default:0,
        name:"stockout_qunatity"
        })
        stockOutQty:number;
        @Column("int",{
            nullable:true,
            name:"stockin_qunatity"
            })
            stockInQty:number;
  @Column("int",{
      nullable:false,
      name:"total_pouches"
      })
      totalPouches:number;
  @Column("int",{
      nullable:false,
      name:"loose_pouches"
      })
      loosePouches:number;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: false,
        name: 'packing_completed',
        default:PackingStatus.NO,
    })
    packingCompleted: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'pouches_shortage',
        default:PackingStatus.NO,
    })
    pouchesShortage: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'cartons_shortage',
        default:PackingStatus.NO,
    })
    cartonsShortage: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'is_damaged',
        default:PackingStatus.NO,
    })
    isDamaged: PackingStatus;
  @Column("int",{
      nullable:false,
      default:0,
      name:"location"
      })
    location:number;
    @Column("int",{
        nullable:false,
        default:0,
        name:"zone_id"
        })
      zoneId:number;
  @Column("int",{
      nullable:false,
      default:0, 
      name:"pallet"
      })
      pallet:number;
      @Column("int",{
        nullable:true,
        name:"pack_style_id"
        })
        packStyleId:number;
  @Column("datetime", {
        nullable: true,
        name: "date"
    })
    date: Date;
    @Column({
        type: 'enum',
        enum: StockStatus,
        nullable: false,
        name: 'stock_type',
        default:"SaleOrder",
    })
    stockType: StockStatus;
    @Column({
        type: 'enum',
        enum: FgStockStatus,
        nullable: false,
        name: 'status',
        default:"StockIn",
    })
    status: FgStockStatus;
    @Column({
        type: 'enum',
        enum: FgStockStates,
        nullable: false,
        name: 'state',
        default:"Stock",
    })
    state: FgStockStates;
   
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'transaction_type',
        default:TransactionType.rm,
    })
    transactionType: TransactionType;
    @Column({
        type: 'enum',
        enum: StockTypesEnum,
        nullable: false,
        name: 'stock_out_category',
        default:"Dispatch",
    })
    stockOutCategory: StockTypesEnum;
    @Column({
        type: 'enum',
        enum: ProductCategoryEnum,
        nullable: false,
        name: 'product_category',
        default:ProductCategoryEnum.GI,
    })
    productCategory: ProductCategoryEnum;
    @Column("int",{
        nullable:false,
        name:"brand_id"
        })
    brandId:number;
    @Column("int",{
        nullable:false,
        name:"product_id"
        })
    productId:number;
    @Column("int",{
        nullable:false,
        name:"unit_id",
        })
    plantId:number;
    @Column("int",{
        nullable:false,
        name:"varient_id"
        })
    varientId:number;
    @Column("int",{
        nullable:false,
        name:"min_grade"
        })
    minGrade:number;
    @Column("int",{
        nullable:false,
        name:"max_grade"
        })
    maxGrade:number;
    @Column("int",{
        nullable:false,
        name:"category_id"
        })
    categoryId:number;
    @Column("int",{
        nullable:true,
        name:"count"
        })
        count:number;
    @Column("int",{
        nullable:false,
        name:"pouches"
        })
    pouches:number;
    @Column("int",{
        nullable:false,
        name:"pallet_capacity",
        default:0
        })
    palletCapacity:number;
    
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "pouch_weight"
    })
    pouchWeight: number;

    @Column("int", {
        nullable: true,
        name: "uom_id"
      })
      uomId: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: true,
        name: "net_weight"
    })
    netWeight: number;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "code"
      })
    code: string;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "remarks"
      })
    remarks: string;
    @Column("int",{
        nullable:true,
        name:"trace_code"
        })
    traceCode:number;
    @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50,
      default:"Admin",
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
}
